import { Check, Minus, X } from "lucide-react";

const COLUMNS = ["Excel e carta", "ERP generico", "Software del fornitore utensili", "Officina Tool Control"];

const ROWS = [
  ["Anagrafica tecnica di utensili e attacchi base", "no", "part", "yes", "yes"],
  ["Giacenze, posizioni fisiche e movimenti per magazzino", "part", "part", "part", "yes"],
  ["Vita utile, consumo taglienti e costo per pezzo", "no", "no", "part", "yes"],
  ["Cicli di lavoro, tempi standard e schede utensili per fase", "no", "part", "no", "yes"],
  ["Planner settimanale, carichi macchina e ore reali", "no", "part", "no", "yes"],
  ["Piani di controllo, quote misurate e non conformità", "no", "part", "no", "yes"],
  ["Preventivi con costo industriale, margine e offerta PDF", "no", "part", "no", "yes"],
  ["Margine di commessa consuntivo con materiale e utensili", "no", "part", "no", "yes"],
  ["Acquisti, fornitori, listini e arrivo merce", "no", "yes", "part", "yes"],
  ["Indipendenza dal fornitore e export dei dati", "yes", "part", "no", "yes"],
];

const ICONS = {
  yes: <Check size={16} />,
  part: <Minus size={16} />,
  no: <X size={16} />,
};

export function ComparisonSection() {
  return (
    <section className="landing-compare" id="confronto" data-testid="landing-comparison">
      <div className="landing-section-head landing-reveal">
        <p className="landing-module-num">CONFRONTO <i /> ONESTO</p>
        <h2>Le alternative, messe in fila</h2>
        <p className="landing-desc">
          Excel funziona finché lo aggiorna una persona sola. L'ERP gestisce documenti, non taglienti. Il
          software del fornitore conosce solo i suoi codici.
        </p>
      </div>

      <div className="landing-compare-scroll landing-reveal">
        <p className="landing-scroll-hint">Scorri la tabella per vedere tutte le colonne →</p>
        <table className="landing-compare-table" data-testid="comparison-table">
          <thead>
            <tr>
              <th className="is-label">Cosa ti serve davvero</th>
              {COLUMNS.map((column, index) => (
                <th key={column} className={index === COLUMNS.length - 1 ? "is-us" : ""}>{column}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ROWS.map(([label, ...values]) => (
              <tr key={label}>
                <td className="is-label">{label}</td>
                {values.map((value, index) => (
                  <td
                    key={`${label}-${index}`}
                    className={`is-${value}${index === values.length - 1 ? " is-us" : ""}`}
                  >
                    {ICONS[value]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="landing-compare-legend landing-reveal">
        <span><Check size={13} /> coperto</span>
        <span><Minus size={13} /> parziale o con personalizzazioni</span>
        <span><X size={13} /> non coperto</span>
      </p>
    </section>
  );
}
